<template>
  <div class="electonicReport">
    <h2>浙医二院解放路二区</h2>
    <h3>{{elcRep.modality}}检查申请单</h3>
    <div class="repTop">
      <ul>
        <li><span>病案号</span>:<p>{{elcRep.mediId}}</p></li>
        <li><span>申请单号</span>:<p>{{elcRep.hisRequestId}}</p></li>
        <li style="width:40%"><span>急诊分级</span>:<p>自定义</p>
          <div class="checked">
            <el-checkbox-group v-model="emergent">
              <el-checkbox label="1" disabled>急</el-checkbox>
              <!-- <el-checkbox label="1" disabled>床边</el-checkbox> -->
            </el-checkbox-group>
          </div>
        </li>
      </ul>
    </div>
    <div class="repMiddle">
      <ul>
        <li><span>姓名</span>:<p>{{elcRep.patientName}}</p></li>
        <li style="width:11%"><span style="width:30px;">性别</span>:<p>{{elcRep.patientSex}}</p></li>
        <li style="width:11%"><span style="width:30px;">年龄</span>:<p>{{elcRep.patientAge}}</p></li>
        <li><span>出生日期</span>:<p>{{elcRep.patientBirth || elcRep.birthday}}</p></li>
        <li><span>联系电话</span>:<p>{{elcRep.patientMobile}}</p></li>
        <li></li>
        <li style="width:11%"  v-if="elcRep.height!== undefined"><span style="width:30px;">身高</span>:<p>{{elcRep.height}}cm</p></li>
        <li style="width:11%"  v-else><span style="width:30px;">身高</span>:<p>{{elcRep.height}}</p></li>
        <li style="width:11%"  v-if="elcRep.weight!== undefined"><span style="width:30px;">体重</span>:<p>{{elcRep.weight}}kg</p></li>
        <li style="width:11%"  v-else><span style="width:30px;">体重</span>:<p>{{elcRep.weight}}</p></li>
        <li><span>科别</span>:<p>{{elcRep.requestDept || elcRep.requestDeptName}}</p></li>
        <li><span>床号</span>:<p>{{elcRep.bedNo}}</p></li>
        <li style="width:54%"><span>陪送方式</span>:
          <div class="checked">
            <el-checkbox-group v-model="ways">
              <el-checkbox label="0" disabled>医生</el-checkbox>
              <el-checkbox label="1" disabled>护士</el-checkbox>
              <el-checkbox label="2" disabled>护工</el-checkbox>
              <el-checkbox label="3" disabled>家属</el-checkbox>
              <el-checkbox label="4" disabled>不陪</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li style="width:20%"><span>送检方式</span>:<p>{{elcRep.inspectionMode}}</p></li>
        <li><span>收费信息</span>:<p>{{elcRep.chargeInfo}}</p></li>
      </ul>
    </div>
    <div class="repContent">
      <ul>
        <li><span>主诉</span>:<p>{{elcRep.patientComplaint}}</p></li>
        <li><span>体征</span>:<p>{{elcRep.patientSign}}</p></li>
        <li><span>病史</span>:<p>
          {{elcRep.patientHistory}}</p>
        </li>
        <li><span>临床诊断</span>:<p>
          {{elcRep.clinicDiagnosis || elcRep.medicalResult}}</p>
        </li>
        <li><span>医生嘱托</span>:<p>{{elcRep.drEntrustment}}</p></li>
        <li><span>项目检查</span>:<p>{{elcRep.examineItems || elcRep.examBodyName}}</p></li>
        <li style="display:inline-block;width:33%"><span>工作单位</span>:<p>{{elcRep.workUnit}}</p></li>
        <li style="display:inline-block;width:33%"><span>住址</span>:<p>{{elcRep.address}}</p></li>
        <li style="display:inline-block;width:32%"><span>职业</span>:<p>{{elcRep.vocation}}</p></li>
      </ul>
    </div>
    <div class="footer">
      <ul>
        <li><span>申请医生</span>:<p>{{elcRep.requestDr || elcRep.requestDoctorName}}</p></li>
        <li><span>医生电话</span>:<p>{{elcRep.requestDrTel}}</p></li>
        <li><span>申请时间</span>:<p>{{elcRep.billApplyDate}}</p></li>
      </ul>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    props: {
      elcRep: {
        type: Object,
        default: function () {
          return {}
        }
      },
      emergent: {
        type: Boolean,
        default: false
      },
      chargeInfo:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        grade: [''],
        ways: [''],

      }
    },
    mounted() {
    },
    methods: {
    },
    created() {
    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .electonicReport
    h2
      line-height: 36px
      font-size: 22px
      text-align: center
      color: #000
    h3
      line-height: 26px
      font-size: 16px
      text-align: center
      color: #000

    .repTop
    .repMiddle
    .footer
      overflow: hidden
      border-bottom: 1px solid #9d9ea3
      li
        float: left
        width: 30%
        line-height: 30px
        min-height: 30px
        .checked
          display: inline-block
        p
          display: inline-block
          margin: 0 6px
          color: #000
        span
          display: inline-block
          color: #9d9ea3
          width: 60px
          text-align-last: justify

    .repMiddle
      margin-bottom: 10px
      li
        width: 26%
        .checked
          margin-left: 10px

    .repContent
      border-bottom: 1px solid #9d9ea3
      padding-bottom: 10px
      li
        overflow: hidden
        vertical-align: top !important
        line-height: 30px
        span
          display: inline-block
          width: 70px
          text-align-last: justify
          color: #9d9ea3
        p
          color: #000
          display: inline-block
          width: calc(100% - 90px)
          margin-left: 10px
          vertical-align: top !important

    .footer
      border-bottom: none
      li
        width: 33%
</style>



// WEBPACK FOOTER //
// electronicReport.vue?704023a2